import * as React from 'react';
import { DisplayDate } from 'owa-datetime';
import { AgendaEventViewBase, Detail, AgendaEventViewBaseProps } from 'owa-agenda-event-views';
import { getDurationString } from '../selectors/userConfigSelectors';
import { formatUserTime } from '../selectors/dateTimeSelectors';
import { observer } from 'mobx-react';

const styles = require('./AgendaEventViewNormal.scss');
const classNames = require('classnames/bind').bind(styles);

export interface AgendaEventViewNormalProps {
    startTime: DisplayDate;
    endTime: DisplayDate;
    organizerEmail: string;
    organizerName: string;
    location: string;
    subject: string;
    isCancelled: boolean;
    isAllDay: boolean;
    isMeeting: boolean;
}

function withNormalView(
    AgendaEventViewBase: React.ComponentClass<AgendaEventViewBaseProps>
): React.ComponentType<
    Omit<AgendaEventViewBaseProps, 'details' | 'timeDetails'> & AgendaEventViewNormalProps
> {
    const AgendaEventViewNormal = observer(
        class extends React.Component<AgendaEventViewBaseProps & AgendaEventViewNormalProps> {
            render() {
                const {
                    isAllDay,
                    startTime,
                    endTime,
                    isCancelled,
                    subject,
                    location,
                    className,
                    organizerName,
                    isMeeting,
                    ...passThroughProps
                } = this.props;
                const details: Detail[] = [];

                details.push({
                    getText: () => subject,
                    className: classNames(styles.subject, styles.subjectNormal, {
                        isCancelled: isCancelled,
                    }),
                });
                if (location) {
                    details.push({ getText: () => location, className: styles.secondDetail });
                }

                if (!location && isMeeting && organizerName) {
                    details.push({ getText: () => organizerName, className: styles.secondDetail });
                }

                const timeDetails = [
                    { getText: () => formatUserTime(startTime), className: styles.timePrimaryText },
                    {
                        getText: () => getDurationString(startTime, endTime),
                        className: styles.timeSecondaryText,
                    },
                ];

                return (
                    <AgendaEventViewBase
                        {...passThroughProps}
                        details={details}
                        timeDetails={timeDetails}
                        className={className}
                    />
                );
            }
        }
    );

    return AgendaEventViewNormal;
}

export const AgendaEventViewNormal = withNormalView(AgendaEventViewBase);
